import botBadgePng from '../../assets/badge/bot.png';

export interface BotBadgeProps {
  /** Pixel size of the badge. Defaults to 12px (cast-strip scale per
   * Visual Spec §5.2). Profile cards use 24px+. */
  size?: number;
  /** Where to anchor the badge relative to its parent's bounding box.
   * `'top-right'` is the canonical position from the spec. */
  anchor?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

/**
 * The 12px gold hexagon overlay that marks a bot. Per Visual Spec §5.2
 * + Bot Spec §7.4 — present on every bot avatar at every UI scale.
 *
 * <p>Uses the commission-grade `badge/bot.png` asset (gold gradient,
 * navy outline, white circuit-spark glyph, drop shadow). Single source;
 * the same PNG scales linearly across UI sizes via CSS.
 */
export function BotBadge({ size = 12, anchor = 'top-right' }: BotBadgeProps) {
  const offset = -Math.round(size / 4);
  const positionStyle: React.CSSProperties = {
    position: 'absolute',
    width: size,
    height: size,
    pointerEvents: 'none',
    filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.35))',
  };
  if (anchor === 'top-right') {
    positionStyle.top = offset;
    positionStyle.right = offset;
  } else if (anchor === 'top-left') {
    positionStyle.top = offset;
    positionStyle.left = offset;
  } else if (anchor === 'bottom-right') {
    positionStyle.bottom = offset;
    positionStyle.right = offset;
  } else {
    positionStyle.bottom = offset;
    positionStyle.left = offset;
  }
  return <img src={botBadgePng} alt="bot" style={positionStyle} />;
}
